import React from 'react';
import { CheckboxWrapSC, CheckboxSC } from './plain-checkbox.styled';
import classNames from 'classnames';

function PlainCheckbox({ checked, children, label, name, value, onChange }) {
  return (
    <CheckboxWrapSC>
      <CheckboxSC active={checked}>
        <input type="checkbox" value={value} name={name} checked={checked} onChange={onChange} />
        <div
          className={classNames('ch-circle', {
            'no-label': name ? false : true,
          })}
        >
          <div className="ch-inner" />
        </div>
      </CheckboxSC>
      <span className="ch-label">{label}</span>
    </CheckboxWrapSC>
  );
}

export default PlainCheckbox;
